// extracted by mini-css-extract-plugin
export var container = "_b5-0";
export var icon = "_b5-1";
export var text = "_b5-2";